import { useAppSelector } from '@store';
import UserRolesColumn from '../../components/common/column/column-roles';

import cn from './styles.module.css';

const RolesColumn = ({
  isLoading,
}: {
  isLoading: boolean;
}): React.JSX.Element => {
  const {
    roles: { roles, roleId },
    confirm: { popupIsOpen },
  } = useAppSelector((state) => state.userRoles);

  return (
    <div className={cn.columnWrapper}>
      <UserRolesColumn
        roles={roles}
        isLoading={isLoading}
        roleId={roleId}
        popupIsOpen={popupIsOpen}
      />
    </div>
  );
};

export default RolesColumn;
